import React, { useEffect, useState, } from "react";
import Select from "react-select";
import './reports.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../../libraries/loader/loader";
import { getReportGridDataFromServer } from '../../../../services/demo/medical-insurance/medicalInsuranceReportService';
import axios from "axios";
import excelIcon from '../../../../assets/images/excel.png';
import * as XLSX from 'xlsx';
import { Icon, Input, Button, Dropdown, Grid, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label } from 'semantic-ui-react'
import {baseUrl_1} from "../../../../services/common/credentials";

const port = 2200;
const port1 = 1100;

var local_host = baseUrl_1 + port;
var local_host1 = baseUrl_1 + port1;

function MedicalInsuranceReport() {

    const [selectedOptionsPolicyType, setSelectedOptionsPolicyType] = useState(undefined);
    const [selectedOptionsInsuranceCompany, setselectedOptionsInsuranceCompany] = useState(undefined);
    const [inputMonth, setInputMonth] = useState(undefined);
    const [hideResultGrid, setHideResultGrid] = useState(true);
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [rowData, setRowData] = useState(undefined);
    const [paginationSize] = useState(15);
    const [companyname, setCompanyName] = useState({});
    const [clientname, setClientName] = useState({});
	const [modelcolumnnames, setmodelcolumnnames] = useState([]);
	const [modelcolumnnames1, setmodelcolumnnames1] = useState([]);

    const [compynames, setCompyNames] = useState([{ value: "", label: "None" },]);
    const [clientnames, setClientNames] = useState([{ value: "", label: "None" },]);
	const [reporttype, setreporttype] = useState({});
    const [isdisablecompanyname, setisdisablecompanyname] = useState(false);

    

    const insuranceCompanyOptionsList = [
        { value: "ICICI Lombard General Insurance Company Limited", label: " ICICI Lombard General Insurance Company Limited" },
        { value: "United India Insurance Company Limited", label: " United India Insurance Company Limited" },
        { value: "National Insurance Company Limited", label: "National Insurance Company Limited" },
        { value: "No Insurance", label: "No Insurance" },
        { value: "Care Health Insurance Company Limited", label: "Care Health Insurance Company Limited" },
        { value: "IFFCO TOKIO GENERAL INSURANCE COMPANY LIMITED", label: "IFFCO TOKIO GENERAL INSURANCE COMPANY LIMITED" },
        { value: "The New India Assurance Co Ltd", label: "The New India Assurance Co Ltd" },
        { value: "The Oriental Insurance Company Limited", label: "The Oriental Insurance Company Limited" },
        { value: "Bajaj Allianz General Insurance", label: "Bajaj Allianz General Insurance" },
        { value: "ManipalCigna ProHealth Group Insurance Policy", label: "ManipalCigna ProHealth Group Insurance Policy" },
        { value: "Max Bupa Health insurance Company Limited & (GPA) TATA AIG General Insurance company Limited", label: "Max Bupa Health insurance Company Limited & (GPA) TATA AIG General Insurance company Limited" },
        { value: "Edelweiss General Insurance", label: "Edelweiss General Insurance" },
        { value: "Reliance General Insurance Co. Ltd.", label: "Reliance General Insurance Co. Ltd." },
        { value: "TATA AIG General insurance co", label: "TATA AIG General insurance co" },
        { value: "Magma HDI General Insurance Company Ltd", label: "Magma HDI General Insurance Company Ltd" },
        { value: "SHRIRAM General Insurance Company Limited", label: "SHRIRAM General Insurance Company Limited" },
    ];
    
    useEffect(() => {
        setLoaderOpen(false);
    }, []);

    const makeAPICall = async (url) => {
        try {
            setLoaderOpen(true);
            console.log(url);
            const response = await fetch(url);
            const data = await response.json();
			setmodelcolumnnames1((prevState) => [
            ...prevState,
            ...data]);
            //setRowData(json_data);
            
            setHideResultGrid(false);
            setLoaderOpen(false);
        }
        catch (e) {
            console.log(e);
            setLoaderOpen(false);
            setHideResultGrid(true);
        }
    }
	
	const intColumnDefs3 = React.useMemo(() => {
    if (modelcolumnnames1?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(modelcolumnnames1[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true,
          width: 100
        })),
      ];
	  console.log("header",intColumnDefs)
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [modelcolumnnames1]);
  
    

    const customStyles = {
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            marginTop: 0,
            paddingTop: -5,
            fontSize: 14,
           
        })
    };


    // function getPolicytype(data) {
    //     setSelectedOptionsPolicyType(data);
    //     console.log(data);
    // }

    function getInsuranceCompany(data) {
        setselectedOptionsInsuranceCompany(data);
        console.log(data);
    }


	const makeAPICall3 = async (url) => {
    console.log('api call3');
    try {
        setLoaderOpen(true);
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const responseData = await response.json();
        console.log("data", responseData);

        var optionList3 = [];

        // Check if mis_insurance_company exists and is an array
        if (Array.isArray(responseData.mis_insurance_company)) {
            responseData.mis_insurance_company.forEach(item => {
                console.log('item', item);
                let object = {
                    value: item,
                    label: item
                };
                optionList3.push(object);
            });
        } else {
            console.log('mis_insurance_company is not an array:', responseData.mis_insurance_company);
        }

        setCompyNames(optionList3);
        setLoaderOpen(false);
        console.log(responseData);
    }
    catch (e) {
        console.log(e);
        setLoaderOpen(false);
    }
}




    function getSetInputMonth(data) {
        setInputMonth(data);
        console.log(data);
        setHideResultGrid(true);
        
    }

    function searchClick(event) {
        if (companyname === undefined) {
            alert("Please Select Report Type!!!");
        }
        // else if(selectedOptionsPolicyType === undefined)
        // {
        //     alert("Please Select Policy Type!!!");
        // }
        // else if(selectedOptionsInsuranceCompany === undefined)
        // {
        //     alert("Please Select Insurance Company!!!");
        // }
        else if (inputMonth === undefined)
        {
            alert("Please Choose the Month!!!");
        }

        else{
            let url = '';
            console.log('nvnbvnvn');
            console.log('companyname', companyname.value);
            console.log('inputMonth', inputMonth);
            if (companyname && companyname.value && clientname && clientname.value) {
                let param = String(companyname.value);
                let param1 = String(clientname.value);
                let param2 = String(inputMonth);
				let report_type = String(reporttype.value);
                url = local_host1+`/api/v2/medical_insurance/master/?companyname=${param}&&clientname=${param1}&&month=${param2}&&reporttype=${report_type}`;
            }
            else if (companyname && companyname.value) {
                let param = String(companyname.value);
                let param1 = String(inputMonth);
				let report_type = String(reporttype.value);
                console.log('paam' + param);
                url = local_host1+`/api/v2/medical_insurance/master/?companyname=${param}&&month=${param1}&&reporttype=${report_type}`;
            }
            else if (clientname && clientname.value) {
                let param1 = String(clientname.value)
				let report_type = String(reporttype.value);
                url = local_host1+`/api/v2/medical_insurance/master/?clientname=${param1}&&month=${param1}&&reporttype=${report_type}`;
            } else {
                let param1 = String(inputMonth);
				let report_type = String(reporttype.value);
                url = local_host1+`/api/v2/medical_insurance/master/?month=${param1}&&reporttype=${report_type}`;
            }
            makeAPICall(url);
        }

    }

    function exportJsonToXLSX(data, sheetName, excelFileName) {
        try {
            var workBook = XLSX.utils.book_new();
            var workSheet = XLSX.utils.json_to_sheet(data, {
                skipHeader: false,
            });
            XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
            XLSX.writeFile(workBook, excelFileName);
            return true;
        }
        catch
        {
            return false;
        }
    }

    function exportToExcel() {
        let fileNameChange = "Report.xlsx";
        let sheetName = "sheet";

        let excelExportData = [];

        for (let i = 0; i < modelcolumnnames1.length; i++) {

            let data = {};
            for (let key in modelcolumnnames1[i]) {
                for (let j = 0; j < modelcolumnnames.length; j++) {
                    if (key === modelcolumnnames[j]["field"]) {
                        data[modelcolumnnames[j]["headerName"]] = modelcolumnnames1[i][key]
                    }
                }
            }

            excelExportData.push(data);
        };

        exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

    }



   

    const makeAPICall2 = async (url) => {
        console.log('api call');
        try {
            var optionList2 = [];
            setLoaderOpen(true);
            const response = await fetch(url);
            if (!response.ok) {
            throw new Error('Network response was not ok');
			}
			const responseData = await response.json();
			console.log("data", responseData);
            if (Array.isArray(responseData.client_name)) {
            responseData.client_name.forEach(item => {
                console.log('item', item);
                let object = {
                    value: item,
                    label: item
                };
                optionList2.push(object);
            });
			} else {
				console.log('mis_client_name is not an array:', responseData.mis_client_name);
			}
            setClientNames(optionList2);
            setLoaderOpen(false);
            
        }
        catch (e) {
            console.log(e);
            
        }
    }

    function getReportType1(data) {
        
        console.log(data.value);
        setHideResultGrid(true);
        if (data && data.value) {
            let url = '';
            console.log('companyname', data.value);
            let param = String(data.value)
            let param1 = String(inputMonth)
			let param2 = String(reporttype.value)
            url = local_host1+`/api/v2/medical_insurance/client_name/?com_name=${param}&&month=${param1}&&reporttype=${param2}`;  
            makeAPICall2(url);  
        }
    }

    function handleChange(data) {
        setCompanyName(data);
        console.log(data.value);
         getReportType1(data);
        setHideResultGrid(true);

    }

    function handleChange1(data) {
        setClientName(data);
        console.log(data.value);
        setHideResultGrid(true);
    }
	
	const reporttype_options = [
        //{ value: "edli", label: "EDLI"},
        //{ value: "ec", label: "EC"},
        { value: "gmc_gpa", label: "GMC & GPA"},
        //{ value: "gpa", label: "GPA"},
        //{ value: "gpl", label: "GPL"},
        //{ value: "health card", label: "Health Card"}
    ];

    const onchangereporttype = (data) =>{
        setreporttype(data);
        setHideResultGrid(true);
        if (data) {
            let url = '';
            let param = data.value;
            let param1 = String(inputMonth);
            console.log('data', param);
			url = local_host1+`/api/v2/medical_insurance/company_name/?month=${param1}&&reporttype=${param}`;  
			setisdisablecompanyname(false);
			makeAPICall3(url);  
        }
        
    }

    return (
        <>
            <div className="report-cardBox">
                <div className="" style={{ marginTop: "2px" }}>
                    <div>
                        <label id="underline_select" htmlFor="underline_select " style={{ fontSize: '15px' }}>Month</label><br />
                        <input type="month" className="cardName filetype" style={{marginTop:'10px' }} onChange={(e) => { getSetInputMonth(e.target.value) }} />
                    </div>
                </div>
				<div className="">
                    <div>
                        <label htmlFor="underline_select " style={{ fontSize: '15px', left: '0px' }}>Reports Type</label> <br />
                        <div className="cardName">
                            <div className="dropdown-containers">
                                <Select
                                    options={reporttype_options}
                                    placeholder="Select Report Type"
                                    value={reporttype}
                                    onChange={onchangereporttype}
                                    isSearchable={true}
                                    styles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="">
                    <div>
                        <label htmlFor="underline_select " style={{ fontSize: '15px', left: '0px' }}>Insurance Company Name</label> <br />
                        <div className="cardName">
                            <div className="dropdown-containers">
                                <Select
                                    options={compynames}
                                    placeholder="Select Company Name"
                                    value={companyname}
                                    onChange={handleChange}
                                    isSearchable={true}
                                    styles={customStyles}
									isDisabled={isdisablecompanyname}
                                />
                            </div>
                        </div>
                    </div>
                </div>
               
                <div className="">
                    <div>
                        <label htmlFor="underline_select " style={{ fontSize: '15px' }}> Client Name</label> <br />
                        <div className="cardName">
                            <div className="dropdown-containers">
                                <Select
                                    options={clientnames}
                                    placeholder="Select Client Name"
                                    value={clientname}
                                    onChange={handleChange1}
                                    isSearchable={true}
                                    styles={customStyles}
									isDisabled={isdisablecompanyname}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                
                {companyname && inputMonth ?
                    <button className="btn" style={{ height: "35px", width: "92px", marginTop: "28px", backgroundColor: "#000055", color: "#ffffff" }} onClick={(e) => { searchClick(e) }}>Search</button>
                    : <button className="btn" disabled={true} style={{ height: "35px", width: "92px", marginTop: "28px", backgroundColor: "#000055", color: "#ffffff" }}>Search</button>
                }
            </div>
            <div className="report" hidden={hideResultGrid}>
                <img src={excelIcon} alt="No Images" style={{ width: '40px', height: '37px' }} className="excel-icon-class" onClick={() => { exportToExcel() }} title="Export" />
                <div className="ag-theme-balham report-layer">
                    <AgGridReact
                        columnDefs={modelcolumnnames}
                        rowData={modelcolumnnames1}
                        paginationPageSize={paginationSize}
                        pagination={true}
                        animateRows={true}
                    >
                    </AgGridReact>
                </div>
            </div>

            <LoaderComponent loaderOpen={loaderOpen} />

        </>
    )
	
}

export default MedicalInsuranceReport;










